/**
 * Payment Status object class with necessary attributes.
 */
export class PaymentStatusModel {

  constructor(public status: string) {

  }
}
